import {Dialog} from "~/components/Dialog";
import React, {useState} from "react";
import {Button, Grid, Rating, RatingProps, TextField, TextFieldProps, useMediaQuery, useTheme} from "@mui/material";


export type FormValues = {
    rating: number
    comment: string
}


export type ServiceInterviewDialogProps = {
    open: boolean
    onSubmit: (values: FormValues) => void
    submitting?: boolean
    onClose?: () => void
}


export const ServiceInterviewDialog = (props: ServiceInterviewDialogProps) => {
    const theme = useTheme();
    const greatXS = useMediaQuery(theme.breakpoints.up("sm"));
    const {open, onClose, onSubmit, submitting} = props;
    const [rating, setRating] = useState<number>(0);
    const [comment, setComment] = useState<string>("");
    const isValid = rating > 0 && rating <= 10;


    const handleRatingChange: RatingProps["onChange"] = (e, value) => {
        setRating(value);
    }

    const handleChangeComment: TextFieldProps["onChange"] = (e) => {
        setComment(e.target.value);
    }

    const handleSubmit = () => {
        if (isValid) {
            onSubmit({rating: rating, comment: comment});
        }
    }

    return (
        <Dialog
            title="Оцените работу сервиса"
            open={open}
            onClose={onClose}
            actions={
                <>
                    <Button size="small" color="additionalSecondary" onClick={onClose}>
                        Позже
                    </Button>
                    <Button size="small" color="additionalPrimary" onClick={() => handleSubmit()}
                            disabled={!isValid || submitting}>
                        Оценить
                    </Button>
                </>
            }
        >
            <Grid container alignItems="center" rowSpacing={"8px"} direction="column">
                <Grid item>
                    <Rating precision={1}
                            max={10}
                            size={greatXS ? "large" : "medium"}
                            value={rating}
                            onChange={handleRatingChange}
                    />
                </Grid>
                <Grid item width="100%">
                    <TextField multiline
                               fullWidth
                               minRows={3}
                               placeholder="Ваш комментарий к оценке"
                               value={comment}
                               onChange={handleChangeComment}
                    />
                </Grid>
            </Grid>
        </Dialog>
    )
}
